import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getMembers = params => {
  return api.get(`admin/members`, {
    params,
  });
};

export const getMembersQueryOptions = params => {
  return queryOptions({
    queryKey: ["members", params],
    queryFn: () => getMembers(params),
  });
};

export const useMembersQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getMembersQueryOptions(params),
    ...queryConfig,
  });
};
